import React from "react";
import "./QuestionBank.css";
import Questions from "../../../assests/updated.json";

function QuestionBank() {
  return (
    <div>
      <div className="ques-section">
        <table id="customer">
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Solution</th>
            <th>Level</th>
            <th>Category</th>
          </tr>
          <br />
          {Questions.map((question) => (
            <>
              <tr>
                <td>{question.Id}</td>
                <td className="name"><a href={question.Link}target="_blank">{question.Name}</a></td>
                <td><a href={question.videourl} target="_blank"><img src="assests/file.png"></img></a></td>
                <td>{question.Level}</td>
                <td>{question.Category}</td>
              </tr>
            </>
          ))}
        </table>
      </div>
    </div>
  );
}

export default QuestionBank;

